import {Route, UrlSegment} from '@angular/router';
import {EEndpointApp} from '@shared/enums/endpoint-app.enum';
import {fnValidUuid} from '@shared/utils/fn.valid.uuid';

export const QR_CODE_TEMPLATE_ROUTE: Route = {
  path: EEndpointApp.Template,
  children: [
    {
      path: EEndpointApp.Overview,
      title: 'overview',
      loadComponent: () => import('./overview/overview.component').then((m) => m.OverviewComponent),
    },
    {
      path: ':id',
      title: 'edit_qrcode_template',
      canMatch: [
        (_route: Route, segments: UrlSegment[]) => {
          return fnValidUuid(segments[0]?.path);
        },
      ],
      loadComponent: () => import('./form/form.component').then((m) => m.FormComponent),
    },
    {
      path: 'new',
      title: 'create_new_qrcode_template',
      loadComponent: () => import('./form/form.component').then((m) => m.FormComponent),
    },
    {
      path: '',
      redirectTo: 'overview',
      pathMatch: 'prefix',
    },
  ],
};
